import React, { useContext } from "react";
import CreateCatalogItemSidebar from "../CreateCatalogItemSidebar/CreateCatalogItemSidebar";
import ICatalog from "@models/ICatalog";
import ICatalog_ItemUI from "@models/ICatalog_ItemUI";
import ICatalog_Item from "@models/ICatalog_Item";
import IUserUI from "@models/IUserUI";
import ISupplierModel from "@models/ISupplierModel";
import AppContext, { useAppContextNonNull } from "@contexts/AppContext";
import IPrice_Group from "@models/IPrice_Group";
import IVendor_Source from "@models/IVendor_Source";

type Props = {
    catalogModel: ICatalog;
    catalogGuid: string;
    catalog_item?: ICatalog_ItemUI;
    cancel: (refreshData?: boolean, item?: ICatalog_Item) => void;
    priceGroups?: IPrice_Group[];
    vendorSources?: IVendor_Source[];
};

export const CreateCatalogItemSidebarWrapper = (props: Props) => {
    const { userModel, supplierModel, uiContext, socket } = useAppContextNonNull();

    return (
        <CreateCatalogItemSidebar
            userModel={userModel}
            supplierModel={supplierModel}
            catalogModel={props.catalogModel}
            catalogGuid={props.catalogGuid}
            notifyFn={uiContext.notifyFn}
            socket={socket}
            catalog_item={props.catalog_item}
            cancel={props.cancel}
            priceGroups={props.priceGroups}
            vendorSources={props.vendorSources}
            showHiddenFeatures={uiContext.showHiddenFeatures}
        />
    );
};
